export enum ReportTypeEnum {
  Daily = "daily report",
  NewDaily = "new daily report",
  Weekly = "weekly report",
}

export enum InsightType {
  PersonalDailyBriefs = "Personal Daily Briefs",
  GlobalReports = "Global Research",
  TopicDeepDives = "Topic Deep-Dives",
  EventDeepDives = "Event Deep-Dives",
  CustomReports = "Custom Reports",
}

export type RouteHandle = {
  sidebarSection?: InsightType;
  pageTitle?: string; // Add this for LayoutBar
};
